export const rules = {
	// Card titles
	"rules.card.rules.title": "Sheria",
	"rules.card.pointsAllocation.title": "Ugawaji wa pointi",
	"rules.card.rulesContinued.title": "Sheria (inaendelea)",
	"rules.card.weeklyPrizes.title": "Muundo wa tuzo za kila wiki",

	// Main rules content
	"rules.intro":
		'Maneno yote yaliyoandikwa kwa herufi kubwa yaliyotumiwa katika sheria hizi (<strong>"Sheria"</strong>) yatachukua ufafanuzi uliowasilishwa katika masharti na hali (<strong>"Masharti na Hali"</strong>).',

	"rules.temporary_notice":
		"Tafadhali kumbuka kuwa washindi wa tuzo katika kipindi cha Desemba 19, 2025 - Januari 2, 2026 watapokea tuzo zao ndani ya siku 7 (saba) kuanzia Januari 6, 2026",

	"rules.rule1":
		"Washiriki wanaweza kupata pointi kwa kutabiri kwa usahihi alama za kila moja ya michezo mitano (5) kila wiki/raundi (kulingana na hali), inayohusiana na ushindani wa michezo ambao mchezo wa Betway Scores BW ScorePredict unahusiana nao, kwa mfano <em>Ligi Kuu ya Uingereza</em>, n.k. Ushindani wa Betway Scores BW Score Predict utaanza Machi 11, 2025 na utamalizika mwishoni mwa msimu wa mpira wa miguu 2025/2026.",

	"rules.rule2.main":
		"Washiriki wanaweza kupata pointi za ziada za bonasi kwa kutabiri kwa usahihi yafuatayo katika kila moja ya michezo mitano (5):",
	"rules.rule2.a": "Alama ya mwisho sahihi",
	"rules.rule2.b": "Mshindi sahihi",
	"rules.rule2.c": "Magoli ya nyumbani sahihi",
	"rules.rule2.d": "Magoli ya nje sahihi",
	"rules.rule2.e": "Tofauti ya magoli sahihi",

	"rules.rule3": "Kila wiki/raundi inahusiana na raundi za ushindani huo wa michezo.",

	"rules.rule4": "Pointi zinagawiwa kama ifuatavyo kwa kila moja ya utabiri sahihi ufuatao wa Mshiriki kila wiki/raundi:",

	// Points allocation
	"rules.points.correctScore": "Alama ya mwisho sahihi",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Mshindi sahihi",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Magoli ya nyumbani sahihi",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Magoli ya nje sahihi",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Tofauti ya magoli sahihi",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Washiriki wanaweza kufanya mabadiliko ya utabiri wao wakati wowote, hadi dakika 15 kabla ya kuanza kwa kila moja ya michezo ya wiki/raundi husika.",

	"rules.rule6":
		"Watumiaji wote waliosajiliwa wa Betway Scores na/au BW Scores wanastahili kucheza Betway Scores BW ScorePredict, hata hivyo ni washiriki wenye akaunti ya Betway iliyothibitishwa tu, wakati tuzo zinapaswa kutolewa, wanastahili kushinda tuzo. Mabadiliko ya matokeo ya mchezo kulingana na hatua ya 2. hapo juu yanayotokea baada ya kutolewa kwa tuzo (kwa mfano kufutwa kwa matokeo) hayatazingatiwa kinyume.",

	"rules.rule7":
		"Mshiriki aliyestahili na anayestahili ambaye atamaliza msimu katika nafasi ya kwanza na ana Akaunti ya Betway atakuwa mshindi wa Tuzo Kuu ya msimu na atashinda safari ya watu wawili (2) kuona Arsenal wakicheza London, ikijumuisha ndege (ikiwa inahitajika), malazi (ikiwa inahitajika) na £500 za matumizi.",

	"rules.rule8":
		"Ikiwa mshindi wa Tuzo Kuu ya msimu hawezi kusafiri kwa sababu ya kutokuwa na pasipoti halali na/au visa na/au kikwazo kingine chochote, atapokea tuzo ya €5,000 ya salio la pesa taslimu, au sawa na kiasi cha karibu katika sarafu ya ndani katika tarehe ya kuanza kwa ushindani (kuwa £4,500, R100,000 au GH₵ 60,000), katika Akaunti yao ya Betway wakati wa kukamilika kwa ushindani.",

	"rules.rule9":
		"Mshindi wa Tuzo Kuu ya msimu anaweza kuchagua kutochukua uzoefu na badala yake kukubali tuzo ya €5,000 ya salio la pesa taslimu, au sawa na kiasi cha karibu katika sarafu ya ndani katika tarehe ya kuanza kwa ushindani (kuwa £4,500, R100,000 au GH₵ 60,000), katika Akaunti yao ya Betway.",

	"rules.rule10":
		'Tuzo za Kila Wiki zitatolelwa kwa wachezaji "10 Bora" kila wiki/raundi ambao wana Akaunti halali ya Kubashiri ya Betway. Ikiwa mchezaji wa 10 Bora hana Akaunti ya Kubashiri ya Betway, hatapokea Tuzo ya Kila Wiki.',

	"rules.rule11":
		"Nafasi za kila wiki 1 hadi 10 zitashinda kiasi kifuatacho cha salio la pesa taslimu, kulingana na eneo lao, katika Akaunti yao ya Betway.",

	"rules.rule12":
		"Tuzo za Kila Wiki zitatolelwa ndani ya siku 7 (saba) baada ya kukamilika kwa matokeo ya wiki hiyo na Tuzo Kuu itatolelwa ndani ya siku 7 (saba) baada ya kukamilika kwa ushindani wa Betway Scores BW Score Predict.",

	"rules.rule13":
		"Ikiwa kuna sare kwa Tuzo za Kila Wiki, salio la pesa taslimu kwa nafasi hiyo (na nafasi husika chini yake ambazo zinaathiriwa na sare) litagawanywa kwa usawa kati ya washiriki walio sare.",

	"rules.rule14": "Ikiwa kuna sare kwa Tuzo Kuu, utaratibu wa nasibu utatumiwa kuchagua mmoja tu wa washiriki walio sare kama mshindi wa Tuzo Kuu.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Kwa Raundi",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
